<template>
    <section class="page-main__section tv-section">

        <!-- Section background -->
        <div class="section-bg-wrapper">
            <!-- You can set several background images by inline: above and under the content; '.section-bg' class means that the background is under the content -->
            <div class="section-bg"></div>
            <!-- Set the inline background for the section like below;  '.section-bg_over' class means that the background is above the content -->
            <div class="section-bg section-bg_over"  v-if="bgimg" :style="{'background-image': 'url('+media +'sliders/'+ bgimg +')'}" ></div>
            <div class="section-bg section-bg_over" v-else :style="{'background-image':'url(' + require('../assets/content/tv-bg.png')+')'}"></div>

        </div>
        <!-- /Section background -->

        <!-- Section content -->
        <div class="content-wrapper">
            <div class="section-heading-wrapper">
                <div class="content-wrapper" id="tv">
                    <h2>{{meta.title}}</h2>
                    <router-link :to="{ name: meta.route, params: { category : meta.categories[0].props } }">{{$t('seeAll')}}</router-link>
                </div>
            </div>
            <ul class="items-list">
                <li v-for="movie in items" :key="movie.id">
                    <div class="teaser">
                        <router-link :to="{ name : 'movie-info', params: { id : movie.id}}">
                            <img v-lazy="{
                                src: media + 'covers/' + movie.image,
                                loading: preloaderImage,
                                error: preloaderImage,
                            }" width="178" height="272" :alt="movie.title">
                        </router-link>
                    </div>
                </li>
            </ul>
        </div>
        <!-- /Section content -->
    </section>
</template>

<script>
    import image from "../assets/images/preloader178x272.png"
    export default {
        props:['meta','items','bgimg'],
        name: "HomeTv",
        data(){
            return {
                media: process.env.VUE_APP_MEDIA,
                preloaderImage: image,
            }
        },
    }
</script>

<style scoped>

</style>
